import * as React from "react"
import { useTranslation } from "react-i18next"

import { Toggle, ToggleIcon } from "Catalog/Preview/Popup/DealPopup/DealLine/Styles"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import { IOptionList } from "shared/hubrise/models"
import { Option } from "shared/hubrise/utils"

import { StyledCollapsed, OptionList, OptionLists } from "./Styles"

interface CollapsedProps {
  optionLists: Array<IOptionList>
  optionNames: (optionListName: string) => Array<string>
  expand: () => void
}

const Collapsed = ({ optionLists, optionNames, expand }: CollapsedProps): JSX.Element => {
  const { t } = useTranslation()
  const { variantRef } = useCatalogNavigation()

  const isCustomised = optionLists.some((optionList) => optionNames(optionList.name).length > 0)

  const namesAndPrices = (optionList: IOptionList): Array<string> => {
    const names = optionNames(optionList.name)
    return names.map((name) => {
      const option = optionList.options.find((option) => option.name === name)!
      const price = Option.price(option, variantRef)
      return price.cents === 0 ? name : `${name} (+${price.toHumanString({ isHtml: false })})`
    })
  }

  return (
    <StyledCollapsed onClick={expand}>
      <Toggle>
        <ToggleIcon code="keyboard_double_arrow_down" />
      </Toggle>

      <OptionLists>
        {isCustomised
          ? optionLists.map((optionList, index) => {
              const names = namesAndPrices(optionList)
              if (names.length === 0) return null
              return (
                <OptionList key={index}>{optionList.name + t("general.colon") + " " + names.join(", ")}</OptionList>
              )
            })
          : t("preview.popup.deal.no_option_selected")}
      </OptionLists>
    </StyledCollapsed>
  )
}

export default Collapsed
